module.exports = __webpack_public_path__ + "img/IMG_4144.b101c10d.jpg";